<template>
  <div>
    <div class="datagrid">
      <b-table
        small
        striped
        hover
        :items="items"
        :fields="fields"
        :per-page="perPage"
        :current-page="currentPage"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        table-class="customtable"
        thead-class="customtable__header"
        tbody-tr-class="customtable__tr"
        :busy="busy"
      >
        <template v-slot:cell(Actions)="row" v-if="actions">
          <span
            size="sm"
            @click="edit(row.item)"
            v-if="allowEdit"
            class="customtable__button customtable__button-edit"
          >
            <i class="icon-pencil customtable__icon"></i> Edit
          </span>
          <span
            size="sm"
            class="customtable__button"
            @click="remove(row.item)"
            v-if="allowDelete"
          >
            <i class="icon-bin customtable__icon"></i> Delete
          </span>
        </template>
        <template v-slot:table-busy>
          <loader class="table-busy-state" />
        </template>
      </b-table>
    </div>
    <b-row>
      <b-col cols="4">
        <b-pagination
          size="sm"
          pills
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          aria-controls="my-table"
          id="perPageSelect"
        ></b-pagination>
      </b-col>
      <b-col cols="3">
        <b-form-group
          label="Items per page"
          label-size="sm"
          label-align="right"
          label-for="perPageSelect"
          label-cols="6"
        >
          <b-form-select
            v-model="perPage"
            :options="perPageOptions"
            required
            size="sm"
          ></b-form-select>
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>
<script>
export default {
  data: function () {
    return {
      sortBy: "id",
      sortDesc: true,
      perPage: 10,
      perPageOptions: [5, 10, 15],
      currentPage: 1,
    };
  },
  props: {
    items: {
      type: Array,
    },
    busy: {
      type: Boolean,
    },
    fields: {
      type: Array,
    },
    confirmMessage: {
      type: String,
    },
    actions: {
      type: Array,
    },
  },

  methods: {
    remove(item) {
      this.$bvModal
        .msgBoxConfirm(this.confirmMessage || "Are you sure?", {
          modalClass: "confirm__modal",
          contentClass: "confirm__modal-contents",
          title: "Please Confirm",
          size: "sm",
          buttonSize: "sm",
          cancelVariant: "light",
          okTitle: "YES",
          cancelTitle: "NO",
          centered: true,
        })
        .then((value) => {
          if (value) {
            this.deleteItem(item);
          }
        })
        .catch((err) => {
          // An error occurred
        });
    },

    deleteItem(item) {
      this.$emit("delete", { vm: this, data: item });
    },

    edit(item) {
      this.$emit("edit", { vm: this, data: item });
    },
  },
  computed: {
    totalRows() {
      return this.items.length ? this.items.length : 0;
    },
    allowDelete() {
      return this.actions && this.actions.indexOf("delete") > -1;
    },
    allowEdit() {
      return this.actions && this.actions.indexOf("edit") > -1;
    },
  },
};
</script>
<style scoped>
.datagrid {
  min-height: 100px;
}
.customtable {
  position: relative;
}

.customtable__icon {
  font-size: 12px;
}
.customtable__button {
  cursor: pointer;
}
.customtable__button-edit {
  color: orange;
  padding-right: 10%;
}
</style>
